import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { LIVE_LINK } from '../helpers/url_helper'

export const notificationsApi = createApi({
  reducerPath: 'notificationsApi',
  baseQuery: fetchBaseQuery({ baseUrl: `${LIVE_LINK}/notifications` }),
  tagTypes: ['notifications'],
  endpoints: (build) => ({
    fetchAllNotifications: build.query({
      query: (id) => ({ url: `/${id}` }),
      providesTags: () => [{ type: 'notifications', id: 'LIST' }]
    }),
    addNotification: build.mutation({
      query: (newRow) => ({
        url: '/',
        method: 'POST',
        body: newRow
      }),
      async onQueryStarted(newRow, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          notificationsApi.util.updateQueryData('fetchAllNotifications', newRow.module, (draft) => {
            draft.notifications.push(newRow); // Optimistically add the new row to the list
          })
        );

        try {
          await queryFulfilled
        } catch {
          patchResult.undo(); // Revert optimistic addition on failure
        }
      },
      invalidatesTags: [{ type: 'notifications', id: 'LIST' }]
    }),
    updateNotification: build.mutation({
      query: (updatedRow) => ({
        url: `/${updatedRow._id}`,
        method: 'PUT',
        body: updatedRow
      }),
      async onQueryStarted(updatedRow, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          notificationsApi.util.updateQueryData('fetchAllNotifications', updatedRow.module, (draft) => {
            const item = draft.notifications.find((row) => row._id === updatedRow._id);
            if (item) {
              Object.assign(item, updatedRow); // Apply changes optimistically
            }
          })
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo(); // Revert optimistic update on failure
        }
      },
      invalidatesTags: (result, error, updatedRow) => [
        { type: 'notifications', id: updatedRow._id },
        { type: 'notifications', id: 'LIST' }
      ]
    }),
  })
});